import { render, staticRenderFns } from "./MachineTuningIndex.vue?vue&type=template&id=038c6ffb&scoped=true&"
import script from "./MachineTuningIndex.vue?vue&type=script&lang=js&"
export * from "./MachineTuningIndex.vue?vue&type=script&lang=js&"
import style0 from "./MachineTuningIndex.vue?vue&type=style&index=0&id=038c6ffb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c6ffb",
  null
  
)

export default component.exports